import { Controller } from "@hotwired/stimulus";

export default class ExternalPartnersDinitrolBookingController extends Controller {
  connect() {
    const courtesyCarContainer = document.getElementById('courtesy-car-container');
  
    const formattedFrom = document.querySelector('select[name="formatted_from"]');
    const formattedTo = document.getElementById('formatted_to');
  
    const jobWillBeCompletedOn = document.querySelector('input[name="job_will_be_completed_on"]');
    const completionTimeOfDay = document.querySelector('input[name="completion_time_of_day"]');
  
    const carPickupAt = document.querySelector('input[name="car_pickup_at"]');
    const pickupTimeOfDay = document.querySelector('input[name="pickup_time_of_day"]');
  
    formattedFrom.addEventListener('change', function() {
      // Turbo loads the frame of this element, so we need to find the element when the change event happens
      const offerSummaryCourtesyCarContainer = document.getElementById('offer-summary-courtesy-car-container');
  
      const selectedOption = formattedFrom.options[formattedFrom.selectedIndex];
  
      if (selectedOption.dataset.jobWillBeCompletedOn) {
        jobWillBeCompletedOn.value = selectedOption.dataset.jobWillBeCompletedOn;
        completionTimeOfDay.value = selectedOption.dataset.completionTimeOfDay;
  
        carPickupAt.value = selectedOption.dataset.carPickupAt;
        pickupTimeOfDay.value = selectedOption.dataset.pickupTimeOfDay;
  
        formattedTo.innerText = selectedOption.dataset.formattedTo || '';
      }
  
      if (selectedOption.dataset.courtesyCarAvailable === 'false' || !selectedOption.dataset.courtesyCarAvailable) {
        courtesyCarContainer.style.display = 'none';
        offerSummaryCourtesyCarContainer.style.display = 'none';
        courtesyCarContainer.querySelector('input[name="courtesy_car"][value="false"]').checked = true;
      } else if (selectedOption.dataset.courtesyCarAvailable === 'true') {
        courtesyCarContainer.style.display = 'block';
        offerSummaryCourtesyCarContainer.style.display = 'block';
      }
    });
  
    formattedFrom.dispatchEvent(new Event('change'));
  }
}
